'use strict';

module.exports = function whereIn(key, values) {
  var collection = this.items.filter(function (item) {
    return values.indexOf(item[key]) !== -1;
  });

  return new this.constructor(collection);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/whereIn.js
// module id = 1228
// module chunks = 2